import {forEachNode, ready} from '@/shared'
import {renderCarousel} from '@/modules/carousel'
import '@/modules/toggle-content'
import '@/modules/custom-select'
import Vue from 'vue'
import ProductNotification from '@/components/ProductNotification/ProductNotification.vue'

const CarouselElementSelector = '.js-thumbs-carousel'
const CarouselBigElementSelector = '.js-big-carousel'

function getCarouselOptions () {
  return {
    items: 5,
    responsive: {
      320: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  }
}

function getCarouselBigOptions () {
  return {
    items: 1,
    lazyload: false,
    loop: false
  }
}

function productTabs () {
  // store tabs variable
  var myTabs = document.querySelectorAll('.product-tabs__nav > a')

  function myTabClicks (tabClickEvent) {
    for (var i = 0; i < myTabs.length; i++) {
      myTabs[i].classList.remove('active')
    }

    var clickedTab = tabClickEvent.currentTarget

    clickedTab.classList.add('active')

    tabClickEvent.preventDefault()

    var myContentPanes = document.querySelectorAll('.product-tabs > div')

    for (i = 0; i < myContentPanes.length; i++) {
      myContentPanes[i].classList.remove('active')
    }

    var anchorReference = tabClickEvent.target
    var activePaneId = anchorReference.getAttribute('href')
    var activePane = document.querySelector(activePaneId)

    activePane.classList.add('active')
  }

  for (var i = 0; i < myTabs.length; i++) {
    myTabs[i].addEventListener('click', myTabClicks)
  }
}

function productDescToggle () {
  let desc = document.querySelectorAll('.product-desc-inner')
  desc.forEach(function (item) {
    if (item.offsetHeight > 200) {
      item.closest('.product-desc-toggle-outer').classList.add('allow-toggle')
    }
  })
  let btn = document.querySelectorAll('.btn-product-desc-toggle')
  btn.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault()
      this.closest('.product-desc-toggle-outer').classList.add('open')
    })
  })
}

// function productFixed () {
//   var getOffsetTop = function (elem) {
//     var distance = 0
//     if (elem.offsetParent) {
//       do {
//         distance += elem.offsetTop
//         elem = elem.offsetParent
//       } while (elem)
//     }
//     return distance < 0 ? 0 : distance
//   }
//   window.addEventListener('load', (event) => {
//     let actionsWrapper = document.getElementsByClassName('l-product__actions')
//     let offsetTop = getOffsetTop(actionsWrapper[0])
//     var headerElement = document.getElementsByClassName('l-product__fixed')
//     headerElement = headerElement[0]
//     function scroll() {
//       var distance = window.pageYOffset
//       if (distance > offsetTop) {
//         headerElement.classList.add('fixed')
//       } else {
//         headerElement.classList.remove('fixed')
//       }
//     }

//     window.onscroll = function (e) {
//       scroll()
//     }
//   })
//   let fixedTitle = document.getElementsByClassName('l-product__fixed-title')
//   let productTitle = document.getElementsByClassName('l-product__title-product')
//   fixedTitle[0].addEventListener('click', () => {
//     window.scroll({
//       behavior: 'smooth',
//       left: 0,
//       top: getOffsetTop(productTitle[0]) - 60
//     })
//   })
// }

ready(function () {
  const carouselNodes = document.querySelectorAll(CarouselElementSelector)
  const carouselBigNodes = document.querySelectorAll(CarouselBigElementSelector)

  forEachNode(carouselNodes, carouselElement => {
    let carousel = renderCarousel(carouselElement, {
      carouselOptions: getCarouselOptions()
    })

    window.carouselThumbsProduct = carousel

    return carousel
  })

  forEachNode(carouselBigNodes, carouselElement => {
    let carousel = renderCarousel(carouselElement, {
      carouselOptions: getCarouselBigOptions(),
      distanceToLoad: 300
    })

    window.carouselBigProduct = carousel

    carousel.events.on('transitionEnd', function (info, eventName) {
      const infoCarousel = carousel.getInfo()
      const indexCurrent = infoCarousel.index
      const currentItem = infoCarousel.slideItems[indexCurrent]
      const currentImage = currentItem.querySelector('.l-product__image')

      if (currentItem && currentImage) {
        let thumbName = currentImage.getAttribute('id').replace('large', 'thumb')
        let thumbElement = document.querySelector('#' + thumbName)

        if (thumbElement) {
          document.querySelector('#' + thumbName).parentNode.click()
        }
      }
    })

    return carousel
  })

  productTabs()
  productDescToggle()
  // productFixed()
  new Vue({ // eslint-disable-line no-new
    el: '#js-product-notification',

    components: {
      ProductNotification
    },

    render: h => h('ProductNotification')
  })
})



// WEBPACK FOOTER //
// ./src/product.js